import React from 'react';
import { PropTypes } from 'prop-types';
import Isvg from 'react-inlinesvg';
import { useNavigate } from 'react-router-dom';
import Button from 'components/Button';
import Message from 'components/Message';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';
import { makePath } from 'helpers/link-generation';
import { messages } from './ScheduleIncrements.messages';

import './ScheduleIncrementsButton.scss';

const { block, element } = bem('schedules-increments-button');

const ScheduleIncrementsButton = ({ venueId }) => {
  const navigate = useNavigate();
  const handleOnClick = () => navigate(makePath.scheduleIncrements(venueId));

  return (
    <Button className={block()} styled="primary-outline" onClick={handleOnClick}>
      <Isvg src={ICONS.filterVertical} className={element('icon')} />
      <Message className={element('text')} message={messages.title} />
    </Button>
  );
};

ScheduleIncrementsButton.propTypes = {
  venueId: PropTypes.number,
};

export default ScheduleIncrementsButton;
